import { Link } from "@StarberryUtils";
import React, { useState } from "react"
import { Container, Row, Col } from 'react-bootstrap';
// Images
// import VideoPosterLarge from "../../../images/guide/banner03.png"
// import VideoPosterMedium from "../../../images/guide/banner02.png"
// import VideoPosterSmall from "../../../images/guide/banner01.png"
import FeefoLogo from "../../../images/feefo-logo.svg"
import { GetURL, feefo } from "../../Common/site/functions"
// Style
import './GuideBanner.scss';
import PlayVideo from "../../Play/CustomVideo";

import { inViewOptions, containerVariants, fadeInFromBottom, contentItemStagger, contentItem } from '../../Utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";

const MotionCol = motion(Col)

const GuideBanner = (props) => {
    const data = props.data;
    const [isPlaying, setPlaying] = useState(false);
    const [avgReview, setAvgReview] = useState(0);
    const [review, setReview] = useState(0);
    feefo((review) => {
        if (review) {
            setAvgReview(review.rating.rating)
            setReview(review.rating.service.count)
        }
    })

    let url_1 = ['']
    let url_2 = ['']
    if (data && data.CTA_1_Link) {
        url_1 = GetURL(data.CTA_1_Link.id)
    }
    if (data && data.CTA_2_Link) {
        url_2 = GetURL(data.CTA_2_Link.id)
    }


    return (
        <React.Fragment>
            <InView {...inViewOptions}>
                {({ ref, inView }) => (
                    <motion.div
                        className="guide-banner"
                        ref={ref}
                        initial="hidden"
                        animate={inView ? "visible" : "hidden"}
                        variants={containerVariants}
                    >
                        {data && <Container>
                            <Row>
                                <MotionCol lg="7" xl="6" className="order-lg-1" variants={contentItemStagger}>
                                    <div className="guide-section-content">
                                        <motion.h1 variants={contentItem}>{data.Area_Title}</motion.h1>
                                        <motion.p variants={contentItem}>{data.Area_Sub_Title}</motion.p>
                                    </div>
                                    <motion.div className="guide-section-btn" variants={contentItem}>

                                        {data.CTA_1_Link && url_1[1] == 'Internal' ?
                                            <Link to={`/${url_1[0]}/in-${data.Title.split(" ").join("-").toLowerCase()}`} className="btn btn-primary">{data.CTA_1_Label}<i className="icon-arrow"></i></Link>
                                            :
                                            data.Header_CTA_1_Link && url_1[1] == 'External' ?
                                                <a href={`${url_1[0]}`} target="_blank" className="btn btn-primary">{data.CTA_1_Label}<i className="icon-arrow"></i></a>
                                                : ''
                                        }

                                        {data.CTA_2_Link && url_2[1] == 'Internal' ?
                                            <Link to={`/${url_2[0]}`} className="btn btn-primary valuation">{data.CTA_2_Label}<i className="icon-arrow"></i></Link>
                                            :
                                            data.Header_CTA_2_Link && url_2[1] == 'External' ?
                                                <a href={`${url_2[0]}`} target="_blank" className="btn btn-primary valuation">{data.CTA_2_Label}<i className="icon-arrow"></i></a>
                                                : ''
                                        }
                                    </motion.div>
                                    <motion.div className="google-rating" variants={contentItem}>
                                        <div>
                                            <img src={FeefoLogo} alt="Feefo logo" />
                                        </div>
                                        <p>{avgReview}/5 Rating based on  <Link to={`/about/reviews`} className="banner-btn-review">{review} verified reviews </Link></p>
                                    </motion.div>
                                </MotionCol>
                                <Col lg="5" xl="6" className="order-lg-2 img-zoom pr-0">
                                    <motion.div className="guide-section-img"  variants={fadeInFromBottom}>
                                        <picture>
                                            <source media="(min-width:992px)" srcSet={data.Tile_Image?.url} />
                                            <source media="(min-width:768px)" srcSet={data.Tile_Image?.url} />
                                            <img className="" src={data.Tile_Image?.url} alt={data.Tile_Image?.alternativeText} />
                                        </picture>
                                        {data.Embed_Video_URL && 
                                                <PlayVideo 
                                                url={data.Embed_Video_URL}
                                                 icon="icon-play" 
                                                 class="play-btn" 
                                                 buttonName="View Video Guide"
                                                 autoplay={data.AutoPlay}
                                                 repeat={data.Repeat}
                                                 /> 
                                        }
                                    </motion.div>
                                </Col>
                            </Row>
                        </Container>}
                    </motion.div>
                )}
            </InView>
            <PlayVideo
                isOpen={isPlaying}
                isCloseFunction={setPlaying}
                videoId='pXyXoWAuw58'
                isAutoPlay={1}
            />
        </React.Fragment>
    )
}
export default GuideBanner